import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AccountDeletionInfo from "./pages/AccountDeletionInfo/AccountDeletionInfo";
import ArogyaBeeLabsPrivacyPolicy from "./pages/ArogyaBeeLabsPrivacyPolicy/ArogyaBeeLabsPrivacyPolicy";
import DownloadDoctorApp from "./pages/DowloadDoctorApp/DowloadDoctorApp";
import DownloadPatientApp from "./pages/DownloadPatientApp/DownloadPatientApp";
import LabAccountDeletionInfo from "./pages/LabAccountDeletionInfo/LabAccountDeletionInfo";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import DoctorPrivacyPolicy from "./pages/DoctorPrivacyPolicy/DoctorPrivacyPolicy";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail/VerifyEmail";
import DoctorAccountDeletionInfo from "./pages/DoctorAccountDeletionInfo/DoctorAccountDeletionInfo";
import QRArogyaBee from "./pages/QRArogyaBee/QRArogyaBee";
import QRArogyaBeeDoctorPro from "./pages/QRArogyaBeeDoctorPro/QRArogyaBeeDoctorPro";
import QRArogyaBeeLabs from "./pages/QRArogyaBeeLabs/QRArogyaBeeLabs";

const RouteConfig = () => {
  return (
    <Router>
      <Routes>
        <Route path="/ehs/verify-email" element={<VerifyEmail />} />
        <Route path="/ehs/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/ehs/doctor-privacy-policy" element={<DoctorPrivacyPolicy />} />
        <Route path="/ehs/lab-privacy-policy" element={<ArogyaBeeLabsPrivacyPolicy />} />
        <Route path="/ehs/doctor-app" element={<DownloadDoctorApp />} />
        <Route path="/ehs/reset-password" element={<ResetPassword />} />
        <Route path="/ehs/account-deletion-info" element={<AccountDeletionInfo />} />
        <Route path="/ehs/lab-account-deletion-info" element={<LabAccountDeletionInfo />} />
        <Route path="/ehs/patient-app" element={<DownloadPatientApp />} />
        <Route path="/ehs/doctor-account-deletion-info" element={<DoctorAccountDeletionInfo />} />
        <Route path="/ehs/qr/arogyabee" element={<QRArogyaBee />} />
        <Route path="/ehs/qr/arogyabee-doctor-pro" element={<QRArogyaBeeDoctorPro />} />
        <Route path="/ehs/qr/arogyabee-labs" element={<QRArogyaBeeLabs />} />
      </Routes>
    </Router>
  );
};

export default RouteConfig;
